module.exports = __webpack_public_path__ + "static/media/small-ice-left.6f4f2b14.png";